import React, { useState, useRef, useEffect } from "react";
import style from "./mobileLogCard.module.scss"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { Link } from "react-router-dom";
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas";

const MobileLogCard = (props) => {

    const determineDate = type => {
        let current = new Date(props.data.date).toLocaleDateString('fa-IR')
        if (props.type == 'transaction') {
            return current + '  -  ' + toPersianNumber(new Date(props.data.date).getHours()) + ':' + toPersianNumber(new Date(props.data.date).getMinutes())
        } else {
            return current + '  -  ۰۰:۰۰'
        }
    }

    return (
        <div className={style.wrapper}>
            <div className={style.header}>
                <div className={props.type == 'transaction' ? style.iconWrapperGreen : style.iconWrapper}><div className={style.icon}></div></div>
                <p className={style.name}>{props.type == 'transaction' ? 'شارژ کیف پول‌' : toPersianNumber(props.data.title)}</p>
            </div>

            <div className={style.seprator}></div>

            <div className={style.details}>
                <p className={style.title}>مبلغ</p>
                <p className={style.value}>{props.data.amount ? toPersianNumber(numberWithCommas(parseInt(props.data.amount / 10))) : '۰'}</p>
            </div>

            <div className={style.details}>
                <p className={style.title}>{props.type == 'transaction' ? 'کاربر' : 'قیمت‌گذاری'}</p>
                <p className={style.value}>{props.type == 'transaction' ? (props.data.payer && props.data.payer.name ? props.data.payer.name : 'موبیشایی') : toPersianNumber(numberWithCommas(props.data.pricingCount))}</p>
            </div>

            <div className={style.details}>
                <p className={style.title}>تاریخ و ساعت</p>
                <p className={style.value}>{determineDate('total')}</p>
            </div>
        </div>
    );
}

export default MobileLogCard;


// ${determineDate('month')}